import { UserRole } from '~/types/userRole'
import { getUserHomePageByRole } from '~/utils'

const ANONYMOUS_ROUTER_ACCESS = [
  '',
  '/login',
  '/login/register-success',
  '/change-password',
  '/recover',
  '/recover/confirm',
  '/activate-account',
  '/marketplace',
  '/marketplace/search/[catId]',
  '/about',
  '/sales/profile/[id]',
  '/delete-mailing/[email]/[userId]',
  '/newsletter/subscribe',
  '/account-settings/privacy',
  '/account-settings/statue',
  '/account-settings/support',
  '/statue',
  '/privacy',
  '/blog',
  '/blog/article',
  '/api/stripe/webhook'
]

export default defineNuxtRouteMiddleware(to => {
  const nuxt = useNuxtApp()

  const { authenticated, accessToken, userId, role } =
    storeToRefs(useAuthStore()) // make authenticated state reactive
  const userStore = useUserStore()
  const { userInfo } = storeToRefs(userStore) // make authenticated state reactive
  const token: any = useCookie('token') // get token from cookies
  const userIdCookie: any = useCookie('userId') // get token from cookies
  const userRoleCookie: any = useCookie('role') // get token from cookies

  if (token.value) {
    // check if value exists
    authenticated.value = true // update the state to authenticated
    accessToken.value = token.value // update the state to authenticated
    if (userInfo.value) {
      userInfo.value.role = userRoleCookie.value // update the state to authenticated
      userInfo.value.userId = userIdCookie.value // update the state to authenticated
    }
    userId.value = userIdCookie.value
    role.value = userRoleCookie.value
  }

  // if token exists and url is /login redirect to homepage
  if (
    token.value &&
    (to?.fullPath === nuxt.$localePath('login') ||
      to?.fullPath === nuxt.$localePath('/'))
  ) {
    const homePageRoute = getUserHomePageByRole(userInfo.value.role)
    return navigateTo(nuxt.$localePath(homePageRoute))
  }

  const allowedRoles: UserRole[] = (to.meta?.role as UserRole[])?.length
    ? [...(to.meta?.role as UserRole[])]
    : []
  // console.log(allowedRoles)
  if (
    token.value &&
    allowedRoles.length &&
    !allowedRoles.includes(role.value)
  ) {
    abortNavigation()
    return navigateTo(nuxt.$localePath('/'), { redirectCode: 301 })
  }

  // if token doesn't exist redirect to log in

  const allowedRoutes = [
    ...ANONYMOUS_ROUTER_ACCESS.map(
      route => `/${nuxt.$i18n.locale.value}${route}`
    ),
  ]

  //console.log(allowedRoutes, to.fullPath)
  if (!token.value && !isRouteIncluded(to, allowedRoutes)) {
    abortNavigation()
    return navigateTo(nuxt.$localePath('/marketplace'), { redirectCode: 301 })
  }
})

function isRouteIncluded(routeData, allowedRoutes) {
  //console.log(routeData)
  const allowed = allowedRoutes.map(r => {
    if (r.includes('[id]') && routeData?.params?.id) {
      return r.replace('[id]', routeData?.params?.id)
    }
    if (
      r.includes('[email]') &&
      routeData?.params?.email &&
      r.includes('[userId]') &&
      routeData?.params?.userId
    ) {
      return r
        .replace('[email]', routeData?.params?.email)
        .replace('[userId]', routeData?.params?.userId)
    }

    if (
      r.includes('[catId]') &&
      routeData?.params?.catId
    ) {
      return r
        .replace('[catId]', routeData?.params?.catId)
    }

    return r
  })

  return (
    [...allowed].includes(routeData?.fullPath) ||
    [...allowed].includes(routeData?.path)
  )
}
